import { jsx } from "react/jsx-runtime";
import {
  useEditor,
  usePassThroughWheelEvents,
  useValue
} from "@tldraw/editor";
import classNames from "classnames";
import { memo, useEffect, useRef } from "react";
import { useRelevantStyles } from "../../hooks/useRelevantStyles.mjs";
import { DefaultStylePanelContent } from "./DefaultStylePanelContent.mjs";
import { StylePanelContextProvider } from "./StylePanelContext.mjs";
const DefaultStylePanel = memo(function DefaultStylePanel2({
  isMobile,
  styles,
  children
}) {
  const editor = useEditor();
  const enhancedA11yMode = useValue("enhancedA11yMode", () => editor.user.getEnhancedA11yMode(), [
    editor
  ]);
  const ref = useRef(null);
  usePassThroughWheelEvents(ref);
  const defaultStyles = useRelevantStyles();
  if (styles === void 0) {
    styles = defaultStyles;
  }
  useEffect(() => {
    const elm = ref.current;
    if (!elm) return;
    function handlePointerMove(event) {
      editor.markEventAsHandled(event);
    }
    function handleKeyDown(event) {
      if (event.key === "Escape" && ref.current?.contains(editor.getContainerDocument().activeElement)) {
        event.stopPropagation();
        editor.getContainer().focus();
      }
    }
    elm.addEventListener("pointermove", handlePointerMove);
    elm.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => {
      elm.removeEventListener("pointermove", handlePointerMove);
      elm.removeEventListener("keydown", handleKeyDown, { capture: true });
    };
  }, [editor]);
  return styles && /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      "data-testid": "style.panel",
      className: classNames("tlui-style-panel", { "tlui-style-panel__wrapper": !isMobile }),
      "data-ismobile": isMobile,
      "data-enhanced-a11y-mode": enhancedA11yMode,
      children: /* @__PURE__ */ jsx(StylePanelContextProvider, { styles, children: children ?? /* @__PURE__ */ jsx(DefaultStylePanelContent, {}) })
    }
  );
});
export {
  DefaultStylePanel
};
//# sourceMappingURL=DefaultStylePanel.mjs.map
